import { ModalBody, ModalCloseButton, ModalContent, ModalRoot } from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { CianNewbuildingChatButtonContext } from '../../CianNewbuildingChatButtonContext';
import * as styles from './ContactListModal.css';
import { getNewbuildingChatContacts } from '../../utils';
import { ContactListItem } from '../ContactListItem';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ContactListModal = function ContactListModal(_ref) {
  var onClose = _ref.onClose,
    onChatOpen = _ref.onChatOpen;
  var _React$useContext = React.useContext(CianNewbuildingChatButtonContext),
    builders = _React$useContext.builders,
    sellers = _React$useContext.sellers;
  var buildersWithChat = getNewbuildingChatContacts(builders, []);
  var sellersWithChat = getNewbuildingChatContacts([], sellers);
  var handleOpenChange = React.useCallback(function (nextOpen) {
    if (!nextOpen) {
      onClose();
    }
  }, [onClose]);
  var handleChatButtonClick = React.useCallback(function (contact) {
    onClose();
    onChatOpen(contact);
  }, [onChatOpen, onClose]);
  var getChatButtonClickHandler = function getChatButtonClickHandler(contact) {
    return function () {
      return handleChatButtonClick(contact);
    };
  };
  return /*#__PURE__*/_jsx(ModalRoot, {
    open: true,
    onOpenChange: handleOpenChange,
    children: /*#__PURE__*/_jsxs(ModalContent, {
      size: "M",
      children: [/*#__PURE__*/_jsx(ModalCloseButton, {
        title: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
        size: "XS",
        theme: "fill_light",
        icon: /*#__PURE__*/_jsx(IconActionClose12, {})
      }), /*#__PURE__*/_jsx(ModalBody, {
        children: /*#__PURE__*/_jsxs("ul", {
          className: styles['container'],
          "data-testid": "CianNewbuildingChatContactList",
          children: [buildersWithChat.map(function (contact) {
            var _contact$logoUrl;
            return /*#__PURE__*/_jsx(ContactListItem, {
              logoUrl: (_contact$logoUrl = contact.logoUrl) !== null && _contact$logoUrl !== void 0 ? _contact$logoUrl : '',
              subtitle: "\u0417\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A",
              title: contact.name,
              buttonTheme: "fill_primary",
              onClick: getChatButtonClickHandler(contact)
            }, contact.realtyUserId);
          }), sellersWithChat.map(function (contact) {
            var _contact$avatarUrl, _contact$name;
            return /*#__PURE__*/_jsx(ContactListItem, {
              logoUrl: (_contact$avatarUrl = contact.avatarUrl) !== null && _contact$avatarUrl !== void 0 ? _contact$avatarUrl : '',
              subtitle: "\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0435\u043B\u044C \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u0430",
              title: (_contact$name = contact.name) !== null && _contact$name !== void 0 ? _contact$name : '',
              buttonTheme: "fill_secondary",
              onClick: getChatButtonClickHandler(contact)
            }, contact.realtyUserId);
          })]
        })
      })]
    })
  });
};